import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, isTokenExpired, bootstrapTenant } from '@/lib/auth';

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  if (!isAuthenticated() || isTokenExpired()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Ensure tenant ID is available from the JWT before rendering tenant-scoped pages
  bootstrapTenant();

  return <>{children}</>;
};

export default PrivateRoute;
